import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'
export const Wrapper = styled.div`
  width: 100%;
  max-width: 1098px;
  height: calc(100vh - 80px);
  margin: auto;
`
export const Chat = styled(TawkMessengerReact)``

export const MainContent = styled.main`
  display: grid;
  /* grid-template-columns: 4fr 2fr; */
  margin-bottom: 40px;

  ${media.lessThan('large')`
    margin-left: 81px;
  `}

  ${media.lessThan('medium')`
    grid-template-columns: 1fr;
  `}

  .my-clients {
    H2 {
      display: none;
    }
    .container {
      margin-top: 40px;
      margin-left: 0;
    }
  }
`

export const NewServiceModalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'a b'
    'c c';
  .input-filter {
    margin: 0 0px 30px auto;
    grid-area: b;
  }
  button {
    grid-area: a;
    width: 60%;
    height: 60%;
    margin: 0 auto 0 auto;
  }
  .table {
    grid-area: c;
  }
  .empty {
    grid-area: c;
  }
`

export const CardsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 1.16rem;
    margin-bottom: 3.6rem;

    .disabled {
      > a,
      button {
        background: ${theme.colors.xlightGray};
        border-radius: ${theme.border.radius};
      }

      > a:hover,
      button:hover {
        cursor: not-allowed;
        background: ${theme.colors.xlightGray};
        color: ${theme.colors.black};

        > p {
          color: ${theme.colors.black};
        }

        > div {
          background: linear-gradient(180deg, #02b971 0%, #017849 100%);

          > svg path {
            fill: ${theme.colors.white};
          }
        }
      }
    }
  `}
`

export const ShotcutContent = styled.div`
  ${({ theme }) => css`
    margin-right: 8px;

    > h2 {
      font-family: ${theme.font.comfortaa};
      font-weight: ${theme.font.normal};
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.darkGray};
      margin: 20px 0 30px 8px;
      padding-bottom: 10px;
      border-bottom: 1px solid ${theme.colors.xlightGray};
    }
  `}
`

export const CardContent = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: 16px 16px 0px 0px;
    > h2 {
      font-family: ${theme.font.comfortaa};
      font-weight: ${theme.font.xbold};
      font-size: ${theme.font.sizes.xxsmall};
      color: ${theme.colors.darkGray};
      margin: 18px 0 36px 8px;
      padding-bottom: 10px;
      border-bottom: 1px solid ${theme.colors.xlightGray};
    }
  `}
`
export const MyConsumptionContent = styled.div`
  ${({ theme }) => css`
    margin-left: 18px;

    > h2 {
      font-family: ${theme.font.comfortaa};
      font-weight: ${theme.font.xbold};
      font-size: ${theme.font.sizes.xxsmall};
      color: ${theme.colors.darkGray};
      margin: 18px 0 36px 8px;
      padding-bottom: 10px;
      border-bottom: 1px solid ${theme.colors.xlightGray};
    }
  `}
`
